<template>
  <div class="animated fadeInRight ecommerce">
    <el-row :gutter="20">
      <el-col :span="4" class="padding-r-0">
        <admin-shop @shop-change="handleShopChange"></admin-shop>
      </el-col>
      <el-col :span="20">
        <el-card class="">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('storeOrderCartManage.searchCondition') }}</div>
          </div>
          <div class="">
            <el-form :inline="true" :model="conditions" class="flex justify-start">
              <el-form-item>
                <el-input :placeholder="$t('storeOrderCartManage.orderNumber')" v-model="conditions.cartId" clearable>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-select v-model="conditions.state" :placeholder="$t('storeOrderCartManage.selectStatus')"
                  style="width:100%">
                  <el-option value="" :label="$t('storeOrderCartManage.selectStatus')"></el-option>
                  <el-option value="1001" :label="$t('storeOrderCartManage.notPurchased')"></el-option>
                  <el-option value="2002" :label="$t('storeOrderCartManage.waitDeliver')"></el-option>
                  <el-option value="3003" :label="$t('storeOrderCartManage.waitReceive')"></el-option>
                  <el-option value="4004" :label="$t('storeOrderCartManage.waitComment')"></el-option>
                  <el-option value="5005" :label="$t('storeOrderCartManage.applyRefund')"></el-option>
                  <el-option value="6006" :label="$t('storeOrderCartManage.returnSuccess')"></el-option>
                  <el-option value="7007" :label="$t('storeOrderCartManage.refunded')"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-input :placeholder="$t('storeOrderCartManage.productName')" v-model="conditions.prodName" clearable>
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="queryOrders" size="small">
                  {{ $t('storeOrderCartManage.search') }}
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('storeOrderCartManage.orderInfo') }}</div>
          </div>
          <div class="">
            <el-table :data="orderCarts" border style="width: 100%">
              <el-table-column prop="cartId" :label="$t('storeOrderCartManage.orderNumber')" align="center">
              </el-table-column>
              <el-table-column prop="appName" :label="$t('storeOrderCartManage.platform')" align="center">
              </el-table-column>
              <el-table-column prop="shopName" :label="$t('storeOrderCartManage.shop')" align="center">
              </el-table-column>
              <el-table-column :label="$t('storeOrderCartManage.type')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.cartType == '3307' ? $t('storeOrderCartManage.service') :
                    $t('storeOrderCartManage.product') }}
                </template>
              </el-table-column>
              <el-table-column :label="$t('storeOrderCartManage.name')" align="center">
                <template slot-scope="scope">
                  {{ scope.row.cartType == '3307' ? scope.row.prodName : `${scope.row.prodName}(${scope.row.specValue})`
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="cartNum" :label="$t('storeOrderCartManage.quantity')" align="center">
              </el-table-column>
              <el-table-column prop="personName" :label="$t('storeOrderCartManage.userName')" align="center">
              </el-table-column>
              <el-table-column prop="payPrice" :label="$t('storeOrderCartManage.paymentAmount')" align="center">
              </el-table-column>
              <el-table-column prop="stateName" :label="$t('storeOrderCartManage.orderStatus')" align="center">
              </el-table-column>
              <el-table-column prop="createTime" :label="$t('storeOrderCartManage.createTime')" align="center">
              </el-table-column>
              <el-table-column :label="$t('storeOrderCartManage.operation')" align="center">
                <template slot-scope="scope">
                  <el-button size="mini" @click="toOrderDetail(scope.row)">
                    {{ $t('storeOrderCartManage.detail') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>

            <el-pagination @current-change="handlePageChange" :current-page="currentPage" :page-size="pageSize"
              :total="total" layout="total, prev, pager, next">
            </el-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { queryAdminStoreOrderCart } from '@/api/admin/storeOrderCartManage/storeOrderCartManageApi'

export default {
  name: 'StoreOrderCartManage',
  components: {
    'admin-shop': () => import('@/components/shop/adminShop')
  },
  data() {
    return {
      orderCarts: [],
      total: 0,
      records: 0,
      currentPage: 1,
      pageSize: 10,
      conditions: {
        cartId: '',
        state: '',
        shopId: '',
        prodName: ''
      }
    }
  },
  created() {
    this.listOrders()
  },
  methods: {
    async listOrders() {
      try {
        const params = {
          ...this.conditions,
          page: this.currentPage,
          row: this.pageSize
        }
        const res = await queryAdminStoreOrderCart(params)
        this.orderCarts = res.data
        this.total = res.total
        this.records = res.records
        console.log(this.records)
      } catch (error) {
        console.error('获取订单列表失败:', error)
      }
    },
    queryOrders() {
      this.currentPage = 1
      this.listOrders()
    },
    handlePageChange(currentPage) {
      this.currentPage = currentPage
      this.listOrders()
    },
    handleShopChange(shop) {
      this.conditions.shopId = shop.shopId
      this.listOrders()
    },
    toOrderDetail(order) {
      this.$router.push(`/pages/order/aOrderDetail?orderId=${order.orderId}`)
    }
  }
}
</script>

<style scoped>
.padding-r-0 {
  padding-right: 0;
}

.ibox {
  margin-bottom: 20px;
}

.ibox-title {
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 3px 0 0;
  color: inherit;
  margin-bottom: 0;
  padding: 14px 15px 7px;
  min-height: 48px;
}

.ibox-content {
  background-color: #ffffff;
  color: inherit;
  padding: 15px 20px 20px 20px;
  border-color: #e7eaec;
  border-image: none;
  border-style: solid solid none;
  border-width: 1px 0;
}
</style>